import React, { useContext, useState } from "react";
import { LogOut, User, ChevronDown, ChevronUp } from "lucide-react";
import { NavLink, useNavigate } from "react-router-dom";
import { Tooltip } from "antd";
import reports from "../assets/svg/reports.svg";
import survey from "../assets/svg/survey.svg";
import cdm from "../assets/svg/cdm.svg";
import tms from "../assets/svg/tms.svg";
import { AppContext } from "../context/AppContextProvider";
import overview from "../assets/svg/overview.svg";
import assetsManagement from "../assets/svg/assetsManagement.svg";
import gms from "../assets/svg/gms.svg";
import customerSupport from "../assets/svg/customer-support.svg";
import setting from "../assets/svg/setting.svg";
import help from "../assets/svg/help.svg";
import socialMedia from "../assets/svg/socialMedia.svg";
import directory from "../assets/images/telephone.png";
import powerbi from "../assets/images/powerbi.png";
import speech from "../assets/images/speech2.png";
import event from "../assets/images/event.png";

import { useTranslation } from "react-i18next";

const Sidebar2 = ({ role }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const hasPowerBiLinks = user?.powerBiLinks?.length > 0;
  const overviewPath = user?.isElectionMode ? "/election-mode" : "/dashboard";

  const { isOpen, toggle, handleLogout } = useContext(AppContext);
  const [logoutModal, setLogoutModal] = useState(false);
  const [activeItem, setActiveItem] = useState(overviewPath);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [showMore, setShowMore] = useState(false);

  let powerBiLinkItem;
  if (hasPowerBiLinks) {
    powerBiLinkItem = {
      id: 99,
      path: "/powerbi-module",
      name: t("Special Reports"),
      icon: <img src={powerbi} alt="" />
    };
  }

  const sideBarOptions = {
    generalUser: [
      {
        id: 0,
        path: overviewPath,
        name: t("Overview"),
        icon: <img src={overview} alt="" />,
      },
      {
        id: 1,
        path: "/cdm",
        name: t("Constituency"),
        icon: <img src={cdm} alt="" />,
      },
      {
        id: 2,
        path: "/gms",
        name: t("Grievance"),
        icon: <img src={gms} alt="" />,
      },
      {
        id: 3,
        path: "/tms",
        name: t("Task"),
        icon: <img src={tms} alt="" className="colored-icon filter-bright" />,
      },
      {
        id: 4,
        path: "/eventScheduler",
        name: t("Calender Manager"),
        icon: <img src={event} alt="" className="colored-icon filter-bright" />,
      },
      {
        id: 5,
        path: "/reports",
        name: t("Reports"),
        icon: <img src={reports} alt="" className="colored-icon" />,
      },
      {
        id: 6,
        path: "/survey",
        name: t("Surveys"),
        icon: <img src={survey} alt="" className="colored-icon" />,
      },
      {
        id: 7,
        path: "/assets-management",
        name: t("Asset"),
        icon: <img src={assetsManagement} alt="" />,
      },
      {
        id: 8,
        path: "/socialmedia",
        name: t("Social Media"),
        icon: <img src={socialMedia} alt="" />,
      },
      {
        id: 9,
        path: "/chatModule",
        name: t("Chat Module"),
        icon: <img src={directory} alt="" />,
      },
      {
        id: 10,
        path: "/speech-module",
        name: t("Speeches"),
        icon: <img src={speech} alt="" />,
      },
      // {
      //   id: 11,
      //   path: "/customersupport",
      //   name: t("Customer Support"),
      //   icon: <img src={customerSupport} alt="" />,
      // },
      // {
      //   id: 12,
      //   path: "/settings",
      //   name: t("Settings"),
      //   icon: <img src={setting} alt="" />,
      // },
      // {
      //   id: 13,
      //   path: "/helpcenter",
      //   name: t("Help Center"),
      //   icon: <img src={help} alt="" className="bottom-links" />,
      // },
    ],
    data_entry_operator: [
      {
        id: 0,
        path: "/gms",
        name: t("Grievance"),
        icon: <img src={gms} alt="" />,
      },
      {
        id: 1,
        path: "/eventScheduler",
        name: t("Calender Manager"),
        icon: <img src={event} alt="" className="colored-icon filter-bright" />,
      },
      {
        id: 2,
        path: "/settings",
        name: t("Settings"),
        icon: <img src={setting} alt="" />,
      },
    ],
    cadre: [
      {
        id: 0,
        path: "/gms",
        name: t("Grievance"),
        icon: <img src={gms} alt="" />,
      },
      {
        id: 1,
        path: "/tms",
        name: t("Task"),
        icon: <img src={tms} alt="" />,
      },
      {
        id: 2,
        path: "/settings",
        name: t("Settings"),
        icon: <img src={setting} alt="" />,
      },
    ],
    office_manager: [
      {
        id: 0,
        path: "/gms",
        name: t("Grievance"),
        icon: <img src={gms} alt="" />,
      },
      {
        id: 1,
        path: "/tms",
        name: t("Task"),
        icon: <img src={tms} alt="" className="colored-icon filter-bright" />,
      },
      {
        id: 2,
        path: "/settings",
        name: t("Settings"),
        icon: <img src={setting} alt="" />,
      },
    ],
  };

  const menuItem = sideBarOptions[role] || sideBarOptions.generalUser;
  if (
    hasPowerBiLinks &&
    (user?.role === "client" || user?.role === "chief_of_staff")
  ) {
    menuItem.splice(10, 0, powerBiLinkItem);
  }

  // Split menu
  const visibleItems = menuItem.slice(0, 10); // till Special Reports
  const hiddenItems = menuItem.slice(10);

  const handleItemClick = (path) => {
    setActiveItem(path);
  };

  const handleUserIconClick = () => {
    toggle();
  };

  return (
    <div className="flex">
      <div
        className={`fixed left-6 z-[999] transition-all duration-300 ease-in-out pb-5 pt-5 overflow-y-auto
          ${isOpen ? "w-56" : "w-14"} max-h-[100vh] overflow-y-auto
          ${showMore ? "top-[0.5rem]" : "top-[0.5rem]"}
        `}
        onMouseLeave={() => setHoveredItem(null)}
      >
        {/* <div
          className="sidebar2-panel glass-shell shadow-2xl pt-2 rounded-2xl overflow-hidden"
          style={{ borderRadius: "28px" }}
        > */}
        <div
          className="bg-black/60 shadow-2xl pt-2 rounded-2xl overflow-hidden"
          style={{ borderRadius: "28px" }}
        >
          {/* Top User Icon Section */}
          <div className="p-1 border-b border-slate-700/50">
            <button
              onClick={handleUserIconClick}
              className="w-full flex items-center justify-center"
            >
              <div className="w-8 h-8 bg-slate-700 rounded-full flex items-center justify-center hover:bg-slate-600 transition-colors">
                <User className="w-4 h-4 text-slate-300" />
              </div>
              {/* {isOpen && (
                <div className="ml-3 flex-1 text-left">
                  <span className="text-white font-semibold text-base">
                    POLSTRAT
                  </span>
                </div>
              )} */}
            </button>
          </div>

          {/* Navigation Items */}
          <div className="flex flex-col p-2 space-y-1 max-h-100 overflow-y-auto">
            {/* Always visible */}
            {visibleItems.map((item) => (
              <Tooltip placement="right" key={item.id} title={item.name}>
                <NavLink
                  to={item.path}
                  className={`link ${isOpen ? "sidebarLeft" : ""}`}
                  activeclassname="active"
                >
                  <button
                    onClick={() => handleItemClick(item.path)}
                    className={`w-full flex items-center space-x-3 py-2 transition-all duration-200 group ${
                      isOpen ? "justify-start px-3" : "justify-center"
                    } relative ${
                      activeItem === item.path
                        ? " text-white shadow-lg shadow-blue-600/25"
                        : "text-slate-300 hover:bg-slate-700/80"
                    }`}
                  >
                    <div className="flex-shrink-0 w-5 h-5 flex items-center justify-center">
                      {React.cloneElement(item.icon, { className: "w-6 h-6" })}
                    </div>
                    {isOpen && (
                      <span className="font-medium text-sm whitespace-nowrap">
                        {item.name}
                      </span>
                    )}
                  </button>
                </NavLink>
              </Tooltip>
            ))}

            {/* Expand/Collapse */}
            {hiddenItems.length > 0 && (
              <button
                onClick={() => setShowMore(!showMore)}
                className="flex items-center justify-center text-slate-300 hover:text-white py-2"
              >
                {isOpen ? (
                  <div className="flex items-center space-x-2">
                    {showMore ? (
                      <>
                        <ChevronUp className="w-4 h-4" />
                        <span className="text-sm">{t("Show Less")}</span>
                      </>
                    ) : (
                      <>
                        <ChevronDown className="w-4 h-4" />
                        <span className="text-sm">{t("Show More")}</span>
                      </>
                    )}
                  </div>
                ) : showMore ? (
                  <ChevronUp className="w-4 h-4" />
                ) : (
                  <ChevronDown className="w-4 h-4" />
                )}
              </button>
            )}

            {/* Hidden Items */}
            <div
              className={`transition-all duration-300 overflow-hidden ${
                showMore ? "max-h-[2000px]" : "max-h-0"
              }`}
            >
              {hiddenItems.map((item) => (
                <Tooltip placement="right" key={item.id} title={item.name}>
                  <NavLink
                    to={item.path}
                    className={`link ${isOpen ? "sidebarLeft" : ""}`}
                    activeclassname="active"
                  >
                    <button
                      onClick={() => handleItemClick(item.path)}
                      className={`w-full flex items-center space-x-3 py-2 transition-all duration-200 group ${
                        isOpen ? "justify-start px-3" : "justify-center"
                      } relative ${
                        activeItem === item.path
                          ? " text-white shadow-lg shadow-blue-600/25"
                          : "text-slate-300 hover:bg-slate-700/80"
                      }`}
                    >
                      <div className="flex-shrink-0 w-5 h-5 flex items-center justify-center">
                        {React.cloneElement(item.icon, {
                          className: "w-6 h-6 ",
                        })}
                      </div>
                      {isOpen && (
                        <span className="font-medium text-sm whitespace-nowrap">
                          {item.name}
                        </span>
                      )}
                    </button>
                  </NavLink>
                </Tooltip>
              ))}
            </div>
          </div>

          {/* Bottom Section - Logout */}
          <Tooltip placement="right" title="Logout">
            <div className="p-2 border-t border-slate-700/50">
              <button
                onClick={() => setLogoutModal(true)}
                className="w-full flex items-center space-x-3 px-2 py-2 rounded-xl transition-all duration-200 group relative text-slate-300 hover:bg-red-600/20 hover:text-red-400"
              >
                <div className="flex-shrink-0 w-5 h-5 flex items-center justify-center">
                  <LogOut className="w-4 h-4" />
                </div>
                {isOpen && (
                  <span className="font-medium text-sm whitespace-nowrap">
                    {t("Logout")}
                  </span>
                )}
              </button>
            </div>
          </Tooltip>
        </div>
      </div>

      {/* Logout Modal */}
      {logoutModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-xl shadow-2xl max-w-sm w-full mx-4">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                <LogOut className="w-5 h-5 text-blue-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-800">
                Confirm Logout
              </h3>
            </div>
            <p className="text-gray-600 mb-6">
              Are you sure you want to logout? This will end your current
              session.
            </p>
            <div className="flex space-x-3">
              <button
                onClick={() => setLogoutModal(false)}
                className="flex-1 px-4 py-2 bg-gray-100 text-gray-800 rounded-lg hover:bg-gray-200 transition-colors font-medium"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  handleLogout();
                  navigate("/");
                  setLogoutModal(false);
                }}
                className="flex-1 px-4 py-2 bg-[var(--polstrat-primary)] text-white rounded-lg hover:bg-red-700 transition-colors font-medium"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Sidebar2;
